import { render, staticRenderFns } from "./BaseFilter.vue?vue&type=template&id=5e5c8525&scoped=true"
import script from "./BaseFilter.vue?vue&type=script&lang=js"
export * from "./BaseFilter.vue?vue&type=script&lang=js"
import style0 from "./BaseFilter.vue?vue&type=style&index=0&id=5e5c8525&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5c8525",
  null
  
)

export default component.exports